import { render, staticRenderFns } from "./WayGoodsList.vue?vue&type=template&id=9e43182e&scoped=true&"
import script from "./WayGoodsList.vue?vue&type=script&lang=js&"
export * from "./WayGoodsList.vue?vue&type=script&lang=js&"
import style0 from "./WayGoodsList.vue?vue&type=style&index=0&id=9e43182e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e43182e",
  null
  
)

export default component.exports